import React, { useEffect, useRef, useState } from "react";
import { Table, InputNumber, DatePicker, Form } from "antd";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import CardLoading from "../../../components/CardLoading";
import { extractYear } from "../../../utils";
import dayjs from 'dayjs';

const PathwayOverviewTable = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "investment_target_budget/fetch_investmenttargetbudgets";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [editedValues, setEditedValues] = useState({});

  const handleValueChange = (value, budInvId, budId, field) => {
    setEditedValues((prev) => ({
      ...prev,
      [`${budInvId}-${field}`]: { value, budId, budInvId },
    }));
  };

  const handleBlur = (row, field) => {
    const key = `${row?.budInvId}-${field}`;
    const edited = editedValues[key];

    if (edited && edited?.value !== row[field]) {
      const payload = {
        budId: edited?.budId,
        budInvId: edited?.budInvId,
        [field]: edited?.value ?? 0,
      };
      onFinish(payload);
      setEditedValues((prev) => {
        const copy = { ...prev };
        delete copy[key];
        return copy;
      });
    }
  };

  const editableCellRender = (value, row, field) => {
    const key = `${row.budInvId}-${field}`;
    const editedValue = editedValues[key]?.value;
  
    return (
      <InputNumber
        min={0}
        value={
          editedValue !== undefined
            ? editedValue
            : value !== null && value !== undefined
            ? Number(value.toString().replace(/,/g, ""))
            : null
        }
        formatter={(val) =>
          val !== null && val !== undefined
            ? `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : ""
        }
        parser={(val) => (val ? val.replace(/\$\s?|(,*)/g, "") : null)}
        style={{ width: "100%" }}
        onChange={(val) =>
          handleValueChange(val, row?.budInvId, row?.budId, field)
        }
        onBlur={() => handleBlur(row, field)}
      />
    );
  }; 

  const [yearData, setYearData] = useState(dayjs()); 
  // const columns = [
  //   {
  //     title: "#",
  //     key: "index",
  //     className: "custom-name-column",
  //     render: (_, row, index) => {
  //       const visualIndex = data
  //         ?.slice(0, index + 1)
  //         ?.filter((r) => r.rowSpan !== 0)?.length;

  //       return {
  //         children: row?.rowSpan !== 0 ? visualIndex : null,
  //         props: { rowSpan: row?.rowSpan },
  //       };
  //     },
  //   },
  //   {
  //     title: "NISIP Pathway",
  //     dataIndex: "irrigationPathwayName",
  //     key: "irrigationPathwayName",
  //     className: "custom-name-column",
  //     render: (text, row) => ({
  //       children: row.rowSpan !== 0 ? text : null,
  //       props: { rowSpan: row.rowSpan },
  //     }),
  //   },
  //   {
  //     title: "Type of Inv.",
  //     dataIndex: "invType",
  //     key: "invType",
  //   },
  //   {
  //     title: "New Expansion (Acres)",
  //     dataIndex: "budNewExpansion",
  //     key: "budNewExpansion",
  //     align: "right",
  //     render: (value, row) => editableCellRender(value, row, "budNewExpansion"),
  //   },
  //   {
  //     title: "Optimised Existing (Acres)",
  //     dataIndex: "budOptimisedExisting",
  //     key: "budOptimisedExisting",
  //     align: "right",
  //     render: (value, row) =>
  //       editableCellRender(value, row, "budOptimisedExisting"),
  //   },
  //   {
  //     title: "Total Govt and IFI (Billion Ksh.)",
  //     dataIndex: "budTotalGovt",
  //     key: "budTotalGovt",
  //     align: "right",
  //     render: (value, row) => editableCellRender(value, row, "budTotalGovt"),
  //   },
  //   {
  //     title: "Total Matching Private (Billion Ksh.)",
  //     dataIndex: "budTotalMatchingPrivate",
  //     key: "budTotalMatchingPrivate",
  //     align: "right",
  //     render: (value, row) =>
  //       editableCellRender(value, row, "budTotalMatchingPrivate"),
  //   },
  //   {
  //     title: "Pathway Total (Billion Ksh.)",
  //     dataIndex: "budPathwayTotal",
  //     key: "budPathwayTotal",
  //     align: "center",
  //     render: (_, row, index) => {
  //       if (row.rowSpan === 0) return { children: null, props: { rowSpan: 0 } };
  //       const groupedRows = data.slice(index, index + row.rowSpan);

  //       const totalGovt = groupedRows.reduce(
  //         (sum, r) => sum + (Number(r.budTotalGovt) || 0),
  //         0
  //       );
  //       const totalPrivate = groupedRows.reduce(
  //         (sum, r) => sum + (Number(r.budTotalMatchingPrivate) || 0),
  //         0
  //       );

  //       const total = totalGovt + totalPrivate;

  //       return {
  //         children: total.toLocaleString(),
  //         props: { rowSpan: row.rowSpan },
  //       };
  //     },
  //   },

  //   // {
  //   //   title: "Pathway Total (Billion Ksh.)",
  //   //   dataIndex: "budPathwayTotal",
  //   //   key: "budPathwayTotal",
  //   //   render: (text, row) => ({
  //   //     children: row.rowSpan !== 0 ? text : null,
  //   //     props: { rowSpan: row.rowSpan },
  //   //   }),
  //   // },
  //   {
  //     title: "Nt Budget Assigned",
  //     dataIndex: "budActualBudgetAssigned",
  //     key: "budActualBudgetAssigned",
  //     align: "right",
  //     render: (value, row) =>
  //       editableCellRender(value, row, "budActualBudgetAssigned"),
  //   },
  // ];

  const columns = [
    {
      title: "#",
      key: "index",
      className: "custom-name-column",
      render: (_, row, index) => {
        const visualIndex = data
          ?.slice(0, index + 1)
          ?.filter((r) => r.rowSpan !== 0)?.length;

        return {
          children: row?.rowSpan !== 0 ? visualIndex : null,
          props: { rowSpan: row?.rowSpan },
        };
      },
    },
    {
      title: "NISIP Pathway",
      dataIndex: "irrigationPathwayName",
      className: "custom-name-column",
      key: "irrigationPathwayName",
      render: (text, row) => ({
        children: row.rowSpan !== 0 ? text : null,
        props: { rowSpan: row.rowSpan },
      }),
    },
    {
      title: "Type of Inv.",
      dataIndex: "invType",
      key: "invType",
    },
     
    {
      title: "New Expansion (Acres)",
      dataIndex: "budNewExpansion",
      key: "budNewExpansion",
      align: "right",
      render: (value) =>
        value !== null && value !== undefined
          ? Number(value).toLocaleString()
          : "-",
    },

    // {
    //   title: "Optimised Existing (Acres)",
    //   dataIndex: "budOptimisedExisting",
    //   key: "budOptimisedExisting",
    //   align: "right",
    //   render: (value, row) => editableCellRender(value, row, "budOptimisedExisting"),
    // },
    

    {
      title: "Optimised Existing (Acres)",
      dataIndex: "budOptimisedExisting",
      key: "budOptimisedExisting",
      align: "right",
      render: (value, row) =>
        editableCellRender(
          value !== null && value !== undefined
            ? Number(value).toLocaleString()
            : "",
          row,
          "budOptimisedExisting"
        ),
    },
    {
      title: "Total Govt and IFI (Billion Ksh.)",
      dataIndex: "budTotalGovt",
      key: "budTotalGovt",
      align: "right",
      render: (value) =>
        value !== null && value !== undefined
          ? Number(value).toLocaleString()
          : "-",
    },
    {
      title: "Total Matching Private (Billion Ksh.)",
      dataIndex: "budTotalMatchingPrivate",
      key: "budTotalMatchingPrivate",
      align: "right",
      render: (value) =>
        value !== null && value !== undefined
          ? Number(value).toLocaleString()
          : "-",
    },
    {
      title: "Pathway Total (Billion Ksh.)",
      dataIndex: "budPathwayTotal",
      key: "budPathwayTotal",
      align: "center",
      render: (_, row, index) => {
        if (row.rowSpan === 0) return { children: null, props: { rowSpan: 0 } };
        const groupedRows = data.slice(index, index + row.rowSpan);

        const totalGovt = groupedRows.reduce(
          (sum, r) => sum + (Number(r.budTotalGovt) || 0),
          0
        );
        const totalPrivate = groupedRows.reduce(
          (sum, r) => sum + (Number(r.budTotalMatchingPrivate) || 0),
          0
        );

        const total = totalGovt + totalPrivate;

        return {
          children: total.toLocaleString(),
          props: { rowSpan: row.rowSpan },
        };
      },
    },
    {
      title: "NT Budget Assigned",
      dataIndex: "budActualBudgetAssigned",
      key: "budActualBudgetAssigned",
      align: "right",
      render: (value, row) =>
        editableCellRender(
          value !== null && value !== undefined
            ? Number(value).toLocaleString()
            : "",
          row,
          "budActualBudgetAssigned"
        ),
    },
  ];

  const calculateTotal = (field) => {
    if (field === "budPathwayTotal") {
      return data?.reduce(
        (sum, row) =>
          sum +
          (Number(row.budTotalGovt) || 0) +
          (Number(row.budTotalMatchingPrivate) || 0),
        0
      );
    }

    if (field === "budNewExpansion") {
      return data?.reduce((sum, row) => {
        if (row.invType == "Planning*") return sum;
        return sum + (Number(row[field]) || 0);
      }, 0);
    }

    return data?.reduce((sum, row) => sum + (Number(row[field]) || 0), 0);
  };
   
  const onFinish = async (data) => {
    if (!yearData) {
      toast.error("Please select year");
      return;
    }
    data.budYear = extractYear(yearData);
    const res = await dispatch(
      save({
        ...data,
        url: "investment_target_budget/save_investmenttargetbudget",
      })
    );
    if (res?.payload?.success) {
      await fetchTableData(); 
    } else {
      toast.error(res?.payload?.message);
    }
  };
  const [tableData,setTableData] =  useState([])

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        budYear: extractYear(yearData),
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => { 
    fetchTableData();
  }, [yearData]);
 
  useEffect(() => {
    if (data) {
      setTableData(data);   
    }
  }, [data, yearData]);
  
  // if (loading) return <CardLoading />;
 
  return (
    <>
      <div className="flex lg:flex-row flex-col gap-y-[1.25rem] lg:items-center justify-between">
        <div className="form-add-h ">5 Year Targets and Budgets</div>
        <div className="flex justify-end">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="w-full  "
            form={form}
          >
            <DatePicker
              placeholder="Year"
              className="input !w-[10rem]"
              picker="year"
              value={yearData}
              onChange={(value) => setYearData(value)}
            />
          </Form>
        </div>
      </div>

      <Table 
        scroll={{
          x: 1200,
        }}
        className="mt-[1.25rem]"
        rowKey={(record) => record?.key}
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
        bordered
        summary={() => {
          const totalNewExpansion = calculateTotal("budNewExpansion");
          const totalOptimisedExisting = calculateTotal("budOptimisedExisting");
          const totalGovtAndIFI = calculateTotal("budTotalGovt");
          const totalMatchingPrivate = calculateTotal(
            "budTotalMatchingPrivate"
          );
          const totalPathway = calculateTotal("budPathwayTotal");
          const totalBudget = calculateTotal("budActualBudgetAssigned");

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell align="center" index={0} colSpan={3}>
                  Totals
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  {totalNewExpansion.toLocaleString()}
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  {totalOptimisedExisting.toLocaleString()}
                </Table.Summary.Cell>
                <Table.Summary.Cell>{totalGovtAndIFI.toLocaleString()}</Table.Summary.Cell>
                <Table.Summary.Cell>{totalMatchingPrivate.toLocaleString()}</Table.Summary.Cell>
                <Table.Summary.Cell align="center">
                  {totalPathway.toLocaleString()}
                </Table.Summary.Cell>
                <Table.Summary.Cell>{totalBudget.toLocaleString()}</Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
      />
    </>
  );
};

export default PathwayOverviewTable;
